import React from 'react';
export const ContextAlert = React.createContext({});
